export async function parseResponse(requestPromise) {
  const response = await requestPromise;
  return response.data;
}
